// ColorPickerPanel.tsx
import React from 'react';
import { SketchPicker } from 'react-color';
import { Box, Typography } from '@mui/material';
import { ThemeContext } from './ThemeContext';



const ColorPickerPanel = () => {
  const ctx = React.useContext(ThemeContext);
  if (!ctx) return null;

  const {
    primaryColor,
    secondaryColor,
    setPrimaryColor,
    setSecondaryColor,
  } = ctx;

  return (
    <Box sx={{ display: 'flex', gap: 4, mt: 4 }}>
      <Box>
        <Typography>Primary Color</Typography>
        <SketchPicker
          color={primaryColor}
          onChangeComplete={(color) => setPrimaryColor(color.hex)}
        />
      </Box>
      <Box>
        <Typography>Secondary Color</Typography>
        <SketchPicker
          color={secondaryColor}
          onChangeComplete={(color) => setSecondaryColor(color.hex)}
        />
      </Box>
   
    </Box>
  );
};

export default ColorPickerPanel;
